import { types } from "../types/types";

const initialState = {
  loading: false,
  nomencladorNacional: [],
  cuentasNomenclador: []
};

export const nomencladoresReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.contratacionesNomenclador:
      return {
        ...state,
        loading: true,
      };
    case types.contratacionesNomencladorSuccess:
      return {
        ...state,
        nomencladorNacional: action.payload,
        loading: false,
      };
    case types.contratacionesNomencladorError:
      return {
        ...state,
        loading: false,
      };
    case types.contratacionesNomencladorGuardar:
      return {
        ...state,
        nomencladorNacional: [
          ...state.nomencladorNacional,
          action.payload,
        ],
        loading: false,
      };
    case types.contratacionesNomencladorModificar:
      return {
        ...state,
        nomencladorNacional: state.nomencladorNacional.map(
          (item) => item.id === action.payload.id
              ? action.payload
              : item
          ),
        loading: false,
      };

    case types.contratacionesCuentasNomenclador:
    return {
      ...state,
      loading: true,
    };
    case types.contratacionesCuentasNomencladorSuccess:
      return {
        ...state,
        cuentasNomenclador: action.payload,
        loading: false,
      };
    case types.contratacionesCuentasNomencladorError:
      return {
        ...state,
        loading: false,
      };
    case types.contratacionesCuentasNomencladorGuardar:
      return {
        ...state,
        cuentasNomenclador: [
          ...state.cuentasNomenclador,
          action.payload,
        ],
        loading: false,
      };
    case types.contratacionesCuentasNomencladorModificar:
      return {
        ...state,
        cuentasNomenclador: state.cuentasNomenclador.map(
          (item) => item.id === action.payload.id
              ? action.payload
              : item
          ),
        loading: false,
      };
    default:
      return state;
  }
};
